module.exports = __webpack_public_path__ + "media/images/products/banners/tesouro_direto-f9ee8713260760edc13478d39d421950.png";